import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
//import { defaultLayoutPlugin, ToolbarSlot, ToolbarProps} from '@react-pdf-viewer/default-layout';
import { defaultLayoutPlugin} from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/default-layout/lib/styles/index.css';

interface Props {
  pdfPath: string;
}

const PDFViewer: React.FC<Props> = ({ pdfPath }) => {

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    //sidebarTabs: (defaultTabs) => defaultTabs.filter((tab) => tab.title !== 'bookmarks'),
    sidebarTabs: (_) => [],
    // renderToolbar: (Toolbar: (props: ToolbarProps) => React.ReactElement) => (
    //   <Toolbar>
    //     { (slots: ToolbarSlot) => {
    //       const {
    //         CurrentPageInput,
    //         Download,
    //         GoToNextPage,
    //         GoToPreviousPage,
    //         NumberOfPages,
    //         Zoom,
    //         ZoomIn,
    //         ZoomOut,
    //       } = slots;
    //       return (
    //         <div
    //           style={{
    //             alignItems: 'center',
    //             display: 'flex',
    //           }}
    //         >
    //           <div style={{ padding: '0px 2px' }}>
    //             <GoToPreviousPage />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <CurrentPageInput /> / <NumberOfPages />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <GoToNextPage />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <ZoomOut />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <Zoom />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <ZoomIn />
    //           </div>
    //           <div style={{ padding: '0px 2px' }}>
    //             <Download />
    //           </div>              
    //         </div>
    //       );
    //     }}
    //   </Toolbar>
    // ),

  });

  const isExternalUrl = pdfPath.startsWith('http://') || pdfPath.startsWith('https://');
  const isOurStrapi = pdfPath.includes('admin-hics.umbraint.com') || pdfPath.includes('localhost:1337');

  return (
    <div className='pdfviewer-container' style={{ height: '100%', width: '100%', minHeight: '600px' }}>
      {isExternalUrl && !isOurStrapi ? (
        <iframe
          src={pdfPath}
          title="Ficha Técnica"
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'block', width: '100%', height: '100%', minHeight: '600px' }}
        />
      ) : (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.min.js">
          <Viewer fileUrl={pdfPath} plugins={[defaultLayoutPluginInstance]} />
        </Worker>
      )}
    </div>
  );
};

export default PDFViewer;